<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">
                <v-layout align-center>
                  <v-img
                    :src="getImgUrl('TK')"
                    height="40px"
                    width="40px"
                    contain
                  >
                  </v-img>

                  THY {{ $t('Ticket-Transfer') }}
                </v-layout>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click.native="validatorDialog = true">
                    <v-list-tile-title>Validatör</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-card color="grey lighten-5" flat>
              <v-layout row wrap>
                <v-flex xs12 sm6 md2>
                  <v-form ref="formtarih" v-model="valid" lazy-validation>
                    <tarihcomp
                      :etiket="$t('Please-select-a-date')"
                      :detaygizle="false"
                      v-model="date"
                      v-bind:defaultvalue="'ok'"
                      :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    ></tarihcomp>
                  </v-form>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-form ref="formtarih" v-model="valid" lazy-validation>
                    <v-checkbox  label="Dış hat biletler BSP olarak aksın" v-model="disHatBspOlsun" hide-details></v-checkbox>
                  </v-form>
                </v-flex>
                <v-flex xs12 sm10 md8>
                  <v-layout align-start="" justify-start column fill-height>
                    <div v-if="load1">
                      <v-btn
                        small=""
                        @mouseenter="tooltip = true"
                        @mouseleave="tooltip = false"
                        ref="fab"
                        @click="biletaktar()"
                        color="info"
                        fab
                        dark
                      >
                        <v-icon>reply_all</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span> {{ $t('Transfer-Tickets') }} </span>
                      </v-tooltip>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>

          <v-layout row wrap>
            <v-flex xs12 sm6 md6>
              <v-toolbar size="120px" dark color="success">
                <v-toolbar-title>{{
                  $t("Transferred-Tickets")
                }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  flat=""
                  solo-inverted=""
                  hide-details
                  v-model="search3"
                  :label="$t('Search')"
                  append-icon="search"
                ></v-text-field>
              </v-toolbar>
              <v-card>
                <v-data-table
                  :headers="headers"
                  :rows-per-page-items="[20, 50]"
                  :loading="progress"
                  :items="itemsok"
                  :search="search3"
                >
                  <template slot="items" slot-scope="props">
                    <tr item>
                      <td class="text-xs-left">{{ props.item.biletNo }}</td>
                      <td class="text-xs-left">{{ props.item.aciklama }}</td>
                      <v-btn icon class="mx-0" @click="git(props.item)">
                        <v-icon color="teal">search</v-icon>
                      </v-btn>
                    </tr>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="error"
                    icon="warning"
                  >
                     {{ $t('No-records-searched-for', { value: search3}) }}
                  </v-alert>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-toolbar size="120px" dark color="red">
                <v-toolbar-title>{{
                  $t("Tickets-Not-Transferred")
                }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  flat=""
                  solo-inverted=""
                  hide-details
                  v-model="search4"
                  :label="$t('Search')"
                  append-icon="search"
                ></v-text-field>
              </v-toolbar>
              <v-card>
                <v-data-table
                  :headers="headers"
                  :rows-per-page-items="[20, 50]"
                  :loading="progress"
                  :items="itemsno"
                  :search="search4"
                >
                  <template slot="items" slot-scope="props">
                    <tr item>
                      <td class="text-xs-left">{{ props.item.biletNo }}</td>
                      <td class="text-xs-left">{{ props.item.aciklama }}</td>
                      <v-btn icon class="mx-0" @click="git(props.item)">
                        <v-icon color="teal">search</v-icon>
                      </v-btn>
                    </tr>
                  </template>
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="error"
                    icon="warning"
                  >
                     {{ $t('No-records-searched-for', { value: search4}) }}
                  </v-alert>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-snackbar
              :timeout="timeout"
              :top="y === 'top'"
              :bottom="y === 'bottom'"
              :right="x === 'right'"
              :left="x === 'left'"
              :multi-line="mode === 'multi-line'"
              :vertical="mode === 'vertical'"
              v-model="snackbar"
            >
              {{ text1 }}
              <v-btn flat color="pink" @click.native="snackbar = false">{{
                $t("Close")
              }}</v-btn>
            </v-snackbar>
          </v-layout>
          <v-dialog v-model="load" hide-overlay persistent width="400">
            <v-card color="primary" dark>
              <v-card-text>
                  {{ $t('Please-Wait') }} ...
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="validatorDialog"
            scrollable=""
            persistent=""
            max-width="400px"
          >
            <v-card color="grey lighten-5">
              <v-card-title>THY Validatör </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      hide-details
                      :label="$t('Company-Name-v2')"
                      v-model="thyCustomer.FirmaAdi"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      hide-details
                      label="Agency Code"
                      v-model="thyCustomer.AcenteKodu"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      hide-details
                      label="MA Code"
                      v-model="thyCustomer.MaCodeList"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      hide-details
                      label="Validator Code"
                      v-model="thyCustomer.ValidatorCodeList"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="validatorDialog = false"
                  >{{ $t("cancel_button") }}</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  flat
                  @click.native="ThyCustomerSave()"
                  >{{ $t("save_button") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import tool from "../../coper/tools";
import tarihcomp from "@/components/app/customcomp/tarihim";
import logoo from "../../../../assets/control";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";

export default {
  data() {
    return {
      disHatBspOlsun:false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      valid: true,
      search: "",
      headers: [
        {
          text: this.$t('Ticket-No'),
          value: "biletNo",
        },
        {
          text: this.$t("Status"),
          value: "aciklama",
        },
      ],
      EkstreHesap: {
        SirketKodu: "",
        Masraf: {
          Code: "",
        },
        BaslangicTarih: "",
        BitisTarih: "",
        Cari: {
          Kod: "",
        },
        RaporTip: "0",
      },
      currentDebtTotal: 0,
      currentCreditTotal: 0,
      debtTotal: 0,
      creditTotal: 0,
      StartDate: null,
      EndDate: null,
      itemsok: [],
      itemsno: [],
      statecari: [],
      MasrafMerkezi: [],
      searchcari: "",
      dictionary: {
        custom: {
          masrafkodu: {
            required: () => this.$t('Please-choose'),
          },
          tarihsec: {
            required: () => this.$t('Please-choose-a-date'),
          },
          tarihsec1: {
            required: () => this.$t('Please-choose-a-date'),
          },
        },
      },

      renk1: "info",
      dialogfiltre: false,
      hesapkodu: [],
      evraktipi: [],
      anahesap: [],
      tumsirketler: "",
      search4: null,
      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",
      date2: null,
      menu2: false,
      dateFormatted2: "",
      modal2: false,
      loading: false,
      progress: false,
      items: [],
      load: false,
      load1: true,
      search3: "",
      butondurum: true,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",
      tooltip: false,
      el: null,
      validatorDialog: false,
      thyCustomer: {
        FirmaAdi: "",
        AcenteKodu: "",
        MaCodeList: "",
        ValidatorCodeList: "",
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  beforeMount: beforeMount,
  components: {
    tarihcomp: tarihcomp,
    yetkidialog,
    hatadialog,
  },
  watch: {
    searchcari(val) {
      val && this.carigetir(val);
    },
  },
  mounted() {
    this.$validator.localize("en", this.dictionary);
    this.el = this.$refs.fab.$el;
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    if (this.sayfayetki.Status != true) {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    } else {
      this.GetThyCustomer();
    }
  },
  methods: {
    getImgUrl(img) {
      return logoo.logoControl(img);
    },
    biletaktar: biletaktar,
    git: git,
    GetThyCustomer: GetThyCustomer,
    ThyCustomerSave: ThyCustomerSave,
    HataYonetimi(response, request, baslik) {
      this.load = false;
      this.load1 = true;
      //Internal Server Error = 500
      if (response.status === 500) {
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable -" + baslik;
        this.snackbar = true;
      }
    },
  },
};

function git(v) {
  var url =
    "#/bilet/yeni/id?" +
    "isl=get&hyolukod=" +
    v.bilet.HavayoluKodu +
    "&biletno=" +
    v.bilet.BiletNo +
    "&ucustipi=" +
    v.bilet.UcusTipi;
  window.open(url, "_blank");
}

function biletaktar() {
  if (this.$refs.formtarih.validate()) {
    var lang = localStorage.getItem('lang')
    this.load = true;
    this.load1 = false;

    var params = {
      tarih: this.date,
      disHatBspOlsun:this.disHatBspOlsun
    };

    tool.api_post(this, "ArkmanTicketStream/THYStream", params).then(
      (response) => {
        var aktarilan = 0;

        this.itemsok = [];
        this.itemsno = [];

        response.body.forEach((element) => {
          if (element.aciklama == " - BASARILI. ") {
            this.itemsok.push(element);
            aktarilan = aktarilan + 1;
          } else {
            this.itemsno.push(element);
          }
        });


        if (lang=="en")
        {
          this.itemsok.forEach((element) => {
          element.aciklama=" - SUCCESSFUL ";
        });

        this.itemsno.forEach((element) => {
          element.aciklama="- ERROR. ResponseMessage :Attention!!! This Ticket is a registered ticket. You cannot transfer it again.!!!";
        });
        }
       

        this.text1 = this.$t('total-of-ticket-transfers-completed',{value: aktarilan})
        this.snackbar = true;
        this.load = false;
        this.load1 = true;
      },
      (response) => {
        /*
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load1 = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load1 = true
      }
      */
        this.HataYonetimi(response, params, "Aktarım yapılamadı.");
      }
    );
  }
}

function beforeMount() {
  this.dateFormatted = getDateNow1();
  this.date = getDateNow();
}

function getDateNow() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }
  today = yyyy + "-" + mm + "-" + dd;
  return today;
}

function getDateNow1() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }
  today = dd + "." + mm + "." + yyyy;
  return today;
}

function GetThyCustomer() {
  let params = {};
  tool.http_post(this, "GetThyCustomer", params).then(
    (response) => {
      if (response.body.Status == true) {
        this.thyCustomer=response.body.data;
      } else {
        this.text1 = this.$t(response.body.ErrorList[0]);
        this.snackbar = true;
        if (response.body.tanimYok == true) {
          this.validatorDialog = true;
        }
      }
    },
    (response) => {
      this.text1 = this.$t('An-error-has-occurred-Please-try-again');
      this.snackbar = true;
    }
  );
}

function ThyCustomerSave() {
  let params = this.thyCustomer;

  tool.http_post(this, "ThyCustomerSave", params).then(
    (response) => {
      if (response.body.Status == true) {
        this.validatorDialog = false;
        this.thyCustomer=response.body.data;
      } else {
        this.text1 = response.body.ErrorList[0];
        this.snackbar = true;
      }
    },
    (response) => {
      this.text1 = this.$t('An-error-has-occurred-Please-try-again');
      this.snackbar = true;
    }
  );
}
</script>

<style>
</style>
